import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from 'react-helmet';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import apiService from "../apiService";

function Becomepartner() {
    const [formData, setFormData] = useState({
        ownerName: '',
        businessName: '',
        category: 'Repairs & Service',
        phone: '',
        email: '',
        city: '',
        pincode: '',
        experience: '1-3 years'
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submittedApplication, setSubmittedApplication] = useState(null);

    const categories = [
        'Repairs & Service',
        'Home Deep Cleaning',
        'Beauty & Salon',
        'Transportation & Driver',
        'Electrical & Wiring',
        'Plumbing',
        'Appliance Repair',
        'Fashion & Tailoring',
        'Other Services'
    ];

    const benefits = [
        {
            icon: '💰',
            title: '0% Commission for 30 Days',
            desc: 'Keep 100% of your earnings for your first month. No upfront registration fee or hidden setup charges.'
        },
        {
            icon: '⚡',
            title: 'Instant Local Customer Leads',
            desc: 'Our hyperlocal routing engine dispatches nearby customer requests right to your phone.'
        },
        {
            icon: '🏦',
            title: 'Direct Bank Payouts',
            desc: 'Receive your earnings directly into your bank account on a weekly schedule with complete transaction transparency.'
        },
        {
            icon: '📱',
            title: 'Dedicated Partner App',
            desc: 'Manage your appointments, store catalog, customer chats, and revenue tracking easily with the Reliep Partner App.'
        }
    ];

    const steps = [
        {
            step: '01',
            title: 'Submit Application',
            desc: 'Fill out your business details and service specialties in the form below.'
        },
        {
            step: '02',
            title: 'Document & KYC Verification',
            desc: 'Our team verifies your Aadhaar/KYC and business profile within 24 hours.'
        },
        {
            step: '03',
            title: 'Start Getting Orders',
            desc: 'Log in to the Reliep Partner App, receive booking alerts, and grow your income.'
        }
    ];

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.ownerName.trim() || !formData.businessName.trim() || !formData.phone.trim()) {
            alert('Please fill out all required fields.');
            return;
        }

        setIsSubmitting(true);
        const appId = 'RLP-PTR-' + Math.floor(10000 + Math.random() * 90000);

        try {
            await apiService.feedback_submit({
                user_id: 1,
                feedback: `[PARTNER REGISTRATION] AppID: ${appId} | Name: ${formData.ownerName} | Business: ${formData.businessName} | Category: ${formData.category} | Phone: ${formData.phone} | Email: ${formData.email || 'N/A'} | City/Pincode: ${formData.city} - ${formData.pincode} | Experience: ${formData.experience}`
            });
        } catch (err) {
            console.warn('Partner application submit note:', err?.message || err);
        } finally {
            setIsSubmitting(false);
            setSubmittedApplication({
                id: appId,
                ownerName: formData.ownerName,
                businessName: formData.businessName,
                phone: formData.phone
            });
            setFormData({
                ownerName: '',
                businessName: '',
                category: 'Repairs & Service',
                phone: '',
                email: '',
                city: '',
                pincode: '',
                experience: '1-3 years'
            });
        }
    };

    return (
        <div style={{ backgroundColor: '#ffffff', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <Helmet>
                <title>Become a Partner | Join 5,000+ Verified Service Experts on Reliep</title>
                <meta name="description" content="Register your service business or freelancing practice on Reliep. Get verified local leads, 0% commission introductory offer, and direct bank payouts." />
            </Helmet>

            <Navbar />

            {/* HERO SECTION */}
            <section style={{
                background: 'radial-gradient(circle at 85% 20%, #fbf0fb 0%, #ffffff 65%)',
                padding: '64px 20px 80px',
                borderBottom: '1px solid #f2e4f2',
                textAlign: 'center'
            }}>
                <div style={{ maxWidth: '860px', margin: '0 auto' }}>
                    <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '8px',
                        background: '#fbf2fb',
                        border: '1px solid #ebd0eb',
                        padding: '6px 16px',
                        borderRadius: '9999px',
                        fontSize: '0.85rem',
                        fontWeight: 700,
                        color: '#850C85',
                        marginBottom: '20px'
                    }}>
                        <span>🤝</span>
                        <span>Official Reliep Partner Program</span>
                    </div>

                    <h1 style={{
                        fontSize: 'clamp(2.2rem, 4.5vw, 3.4rem)',
                        fontWeight: 800,
                        color: '#0f172a',
                        lineHeight: 1.18,
                        letterSpacing: '-1px',
                        marginBottom: '16px'
                    }}>
                        Grow Your Service Business with{' '}
                        <span style={{
                            color: '#850C85',
                            background: 'linear-gradient(135deg, #850C85 0%, #b81ab8 100%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}>
                            Reliep
                        </span>
                    </h1>

                    <p style={{
                        fontSize: '1.1rem',
                        color: '#475569',
                        lineHeight: 1.6,
                        margin: '0 auto 32px',
                        maxWidth: '700px'
                    }}>
                        Connect with thousands of daily customers across your city. Zero upfront registration fee, flexible working hours, and instant weekly payouts.
                    </p>

                    {/* Quick Login Pill for existing partners */}
                    <div style={{ display: 'inline-flex', alignItems: 'center', gap: '12px', background: '#ffffff', padding: '8px 18px', borderRadius: '9999px', border: '1px solid #f1e2f1', boxShadow: '0 4px 14px rgba(133,12,133,0.08)' }}>
                        <span style={{ fontSize: '0.86rem', color: '#64748b' }}>Already an onboarded partner?</span>
                        <a
                            href="http://localhost:8100/login"
                            target="_blank"
                            rel="noreferrer"
                            style={{
                                color: '#850C85',
                                fontWeight: 800,
                                fontSize: '0.88rem',
                                textDecoration: 'none',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px'
                            }}
                        >
                            <span>Open Partner App</span>
                            <span>↗</span>
                        </a>
                    </div>
                </div>
            </section>

            {/* BENEFITS GRID */}
            <section style={{ padding: '60px 20px', backgroundColor: '#faf8fa' }}>
                <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
                    <div style={{ textAlign: 'center', marginBottom: '44px' }}>
                        <span style={{
                            fontSize: '0.82rem',
                            fontWeight: 800,
                            color: '#850C85',
                            letterSpacing: '1px',
                            textTransform: 'uppercase',
                            display: 'block',
                            marginBottom: '6px'
                        }}>
                            PARTNER ADVANTAGE
                        </span>
                        <h2 style={{ fontSize: '2rem', fontWeight: 800, color: '#0f172a', margin: 0 }}>
                            Why 5,000+ Technicians & Vendors Choose Reliep
                        </h2>
                    </div>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
                        gap: '24px'
                    }}>
                        {benefits.map((b, idx) => (
                            <div
                                key={idx}
                                style={{
                                    backgroundColor: '#ffffff',
                                    borderRadius: '16px',
                                    padding: '28px 24px',
                                    border: '1px solid #f1e2f1',
                                    boxShadow: '0 4px 16px rgba(133, 12, 133, 0.05)',
                                    display: 'flex',
                                    flexDirection: 'column'
                                }}
                            >
                                <div style={{
                                    width: '52px',
                                    height: '52px',
                                    borderRadius: '14px',
                                    background: '#fbf2fb',
                                    color: '#850C85',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '1.6rem',
                                    marginBottom: '16px'
                                }}>
                                    {b.icon}
                                </div>
                                <h3 style={{ fontSize: '1.15rem', fontWeight: 800, color: '#0f172a', margin: '0 0 8px' }}>
                                    {b.title}
                                </h3>
                                <p style={{ fontSize: '0.88rem', color: '#64748b', lineHeight: 1.5, margin: 0 }}>
                                    {b.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* HOW IT WORKS */}
            <section style={{ padding: '70px 20px', backgroundColor: '#ffffff', borderBottom: '1px solid #f2e4f2' }}>
                <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
                    <div style={{ textAlign: 'center', marginBottom: '48px' }}>
                        <span style={{
                            fontSize: '0.82rem',
                            fontWeight: 800,
                            color: '#850C85',
                            letterSpacing: '1px',
                            textTransform: 'uppercase',
                            display: 'block',
                            marginBottom: '6px'
                        }}>
                            SIMPLE ONBOARDING
                        </span>
                        <h2 style={{ fontSize: '2rem', fontWeight: 800, color: '#0f172a', margin: 0 }}>
                            Get Live in 3 Easy Steps
                        </h2>
                    </div>

                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                        gap: '24px'
                    }}>
                        {steps.map((st, idx) => (
                            <div
                                key={idx}
                                style={{
                                    backgroundColor: '#fdf9fd',
                                    borderRadius: '16px',
                                    padding: '30px 24px',
                                    border: '1.5px solid #ebd0eb',
                                    position: 'relative'
                                }}
                            >
                                <span style={{
                                    fontSize: '2.5rem',
                                    fontWeight: 900,
                                    color: '#850C85',
                                    opacity: 0.25,
                                    lineHeight: 1,
                                    display: 'block',
                                    marginBottom: '10px'
                                }}>
                                    {st.step}
                                </span>
                                <h3 style={{ fontSize: '1.2rem', fontWeight: 800, color: '#0f172a', margin: '0 0 8px' }}>
                                    {st.title}
                                </h3>
                                <p style={{ fontSize: '0.9rem', color: '#64748b', lineHeight: 1.5, margin: 0 }}>
                                    {st.desc}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* REGISTRATION FORM SECTION */}
            <section id="partner-form-section" style={{ padding: '80px 20px', backgroundColor: '#faf8fa' }}>
                <div style={{ maxWidth: '800px', margin: '0 auto' }}>
                    <div style={{
                        backgroundColor: '#ffffff',
                        borderRadius: '24px',
                        padding: '40px',
                        border: '1.5px solid #ebd0eb',
                        boxShadow: '0 20px 45px rgba(133, 12, 133, 0.08)'
                    }}>
                        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                            <span style={{
                                fontSize: '0.8rem',
                                fontWeight: 800,
                                color: '#850C85',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                                display: 'block',
                                marginBottom: '6px'
                            }}>
                                APPLICATION FORM
                            </span>
                            <h2 style={{ fontSize: '1.8rem', fontWeight: 800, color: '#0f172a', margin: '0 0 8px' }}>
                                Register as a Reliep Partner
                            </h2>
                            <p style={{ fontSize: '0.92rem', color: '#64748b', margin: 0 }}>
                                Fill out your service information and our onboarding team will reach out within 24 hours.
                            </p>
                        </div>

                        {submittedApplication ? (
                            <div style={{
                                textAlign: 'center',
                                padding: '36px 20px',
                                background: '#fbf2fb',
                                borderRadius: '16px',
                                border: '1.5px solid #ebd0eb'
                            }}>
                                <div style={{
                                    width: '64px',
                                    height: '64px',
                                    borderRadius: '50%',
                                    background: '#850C85',
                                    color: '#ffffff',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '1.8rem',
                                    margin: '0 auto 16px'
                                }}>
                                    ✓
                                </div>
                                <h3 style={{ fontSize: '1.4rem', fontWeight: 800, color: '#0f172a', marginBottom: '8px' }}>
                                    Partner Application Received!
                                </h3>
                                <p style={{ fontSize: '0.92rem', color: '#64748b', marginBottom: '16px' }}>
                                    Congratulations, <strong>{submittedApplication.ownerName}</strong>! Your application for <strong>{submittedApplication.businessName}</strong> has been assigned reference:
                                </p>
                                <span style={{
                                    display: 'inline-block',
                                    background: '#ffffff',
                                    border: '1.5px solid #ebd0eb',
                                    padding: '8px 20px',
                                    borderRadius: '10px',
                                    fontWeight: 800,
                                    fontSize: '1.2rem',
                                    color: '#850C85',
                                    letterSpacing: '1px',
                                    marginBottom: '20px'
                                }}>
                                    {submittedApplication.id}
                                </span>
                                <p style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '28px' }}>
                                    Our partner onboarding coordinator will call you at <strong>{submittedApplication.phone}</strong> for document verification.
                                </p>

                                <div style={{ display: 'flex', gap: '14px', justifyContent: 'center', flexWrap: 'wrap' }}>
                                    <a
                                        href="http://localhost:8100/login"
                                        target="_blank"
                                        rel="noreferrer"
                                        style={{
                                            background: '#850C85',
                                            color: '#ffffff',
                                            padding: '12px 24px',
                                            borderRadius: '12px',
                                            fontWeight: 700,
                                            fontSize: '0.92rem',
                                            textDecoration: 'none',
                                            boxShadow: '0 4px 12px rgba(133, 12, 133, 0.25)'
                                        }}
                                    >
                                        Go to Partner Login (8100) ↗
                                    </a>
                                    <button
                                        onClick={() => setSubmittedApplication(null)}
                                        style={{
                                            background: '#ffffff',
                                            color: '#475569',
                                            border: '1px solid #cbd5e1',
                                            padding: '12px 20px',
                                            borderRadius: '12px',
                                            fontWeight: 600,
                                            fontSize: '0.92rem',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Register Another Practice
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                                {/* Row 1: Owner Name & Business Name */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', marginBottom: '6px' }}>
                                            Full Name (Owner / Specialist) *
                                        </label>
                                        <input
                                            type="text"
                                            name="ownerName"
                                            value={formData.ownerName}
                                            onChange={handleChange}
                                            placeholder="e.g. Chandan Kumar"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px 14px',
                                                borderRadius: '10px',
                                                border: '1.5px solid #ebd0eb',
                                                outline: 'none',
                                                fontSize: '0.92rem',
                                                boxSizing: 'border-box'
                                            }}
                                            onFocus={(e) => { e.target.style.borderColor = '#850C85'; }}
                                            onBlur={(e) => { e.target.style.borderColor = '#ebd0eb'; }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', marginBottom: '6px' }}>
                                            Business / Practice Name *
                                        </label>
                                        <input
                                            type="text"
                                            name="businessName"
                                            value={formData.businessName}
                                            onChange={handleChange}
                                            placeholder="e.g. Chandan Electronics & Repairs"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px 14px',
                                                borderRadius: '10px',
                                                border: '1.5px solid #ebd0eb',
                                                outline: 'none',
                                                fontSize: '0.92rem',
                                                boxSizing: 'border-box'
                                            }}
                                            onFocus={(e) => { e.target.style.borderColor = '#850C85'; }}
                                            onBlur={(e) => { e.target.style.borderColor = '#ebd0eb'; }}
                                        />
                                    </div>
                                </div>

                                {/* Row 2: Category & Experience */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', marginBottom: '6px' }}>
                                            Primary Service Category *
                                        </label>
                                        <select
                                            name="category"
                                            value={formData.category}
                                            onChange={handleChange}
                                            style={{
                                                width: '100%',
                                                padding: '12px 14px',
                                                borderRadius: '10px',
                                                border: '1.5px solid #ebd0eb',
                                                outline: 'none',
                                                fontSize: '0.92rem',
                                                background: '#ffffff',
                                                boxSizing: 'border-box'
                                            }}
                                            onFocus={(e) => { e.target.style.borderColor = '#850C85'; }}
                                            onBlur={(e) => { e.target.style.borderColor = '#ebd0eb'; }}
                                        >
                                            {categories.map((c) => (
                                                <option key={c} value={c}>{c}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div>
                                        <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', marginBottom: '6px' }}>
                                            Years of Experience
                                        </label>
                                        <select
                                            name="experience"
                                            value={formData.experience}
                                            onChange={handleChange}
                                            style={{
                                                width: '100%',
                                                padding: '12px 14px',
                                                borderRadius: '10px',
                                                border: '1.5px solid #ebd0eb',
                                                outline: 'none',
                                                fontSize: '0.92rem',
                                                background: '#ffffff',
                                                boxSizing: 'border-box'
                                            }}
                                            onFocus={(e) => { e.target.style.borderColor = '#850C85'; }}
                                            onBlur={(e) => { e.target.style.borderColor = '#ebd0eb'; }}
                                        >
                                            <option value="Less than 1 year">Less than 1 year</option>
                                            <option value="1-3 years">1-3 years</option>
                                            <option value="3-5 years">3-5 years</option>
                                            <option value="5+ years">5+ years</option>
                                        </select>
                                    </div>
                                </div>

                                {/* Row 3: Phone & Email */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', marginBottom: '6px' }}>
                                            Mobile Number (for OTP & Bookings) *
                                        </label>
                                        <input
                                            type="tel"
                                            name="phone"
                                            value={formData.phone}
                                            onChange={handleChange}
                                            placeholder="10-digit mobile number"
                                            maxLength={10}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px 14px',
                                                borderRadius: '10px',
                                                border: '1.5px solid #ebd0eb',
                                                outline: 'none',
                                                fontSize: '0.92rem',
                                                boxSizing: 'border-box'
                                            }}
                                            onFocus={(e) => { e.target.style.borderColor = '#850C85'; }}
                                            onBlur={(e) => { e.target.style.borderColor = '#ebd0eb'; }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', marginBottom: '6px' }}>
                                            Email Address
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            placeholder="chandan@example.com"
                                            style={{
                                                width: '100%',
                                                padding: '12px 14px',
                                                borderRadius: '10px',
                                                border: '1.5px solid #ebd0eb',
                                                outline: 'none',
                                                fontSize: '0.92rem',
                                                boxSizing: 'border-box'
                                            }}
                                            onFocus={(e) => { e.target.style.borderColor = '#850C85'; }}
                                            onBlur={(e) => { e.target.style.borderColor = '#ebd0eb'; }}
                                        />
                                    </div>
                                </div>

                                {/* Row 4: City & Pincode */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', marginBottom: '6px' }}>
                                            Operating City *
                                        </label>
                                        <input
                                            type="text"
                                            name="city"
                                            value={formData.city}
                                            onChange={handleChange}
                                            placeholder="e.g. Kolkata"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px 14px',
                                                borderRadius: '10px',
                                                border: '1.5px solid #ebd0eb',
                                                outline: 'none',
                                                fontSize: '0.92rem',
                                                boxSizing: 'border-box'
                                            }}
                                            onFocus={(e) => { e.target.style.borderColor = '#850C85'; }}
                                            onBlur={(e) => { e.target.style.borderColor = '#ebd0eb'; }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{ display: 'block', fontSize: '0.85rem', fontWeight: 700, color: '#0f172a', marginBottom: '6px' }}>
                                            Service Pincode *
                                        </label>
                                        <input
                                            type="text"
                                            name="pincode"
                                            value={formData.pincode}
                                            onChange={handleChange}
                                            placeholder="6-digit pincode"
                                            maxLength={6}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px 14px',
                                                borderRadius: '10px',
                                                border: '1.5px solid #ebd0eb',
                                                outline: 'none',
                                                fontSize: '0.92rem',
                                                boxSizing: 'border-box'
                                            }}
                                            onFocus={(e) => { e.target.style.borderColor = '#850C85'; }}
                                            onBlur={(e) => { e.target.style.borderColor = '#ebd0eb'; }}
                                        />
                                    </div>
                                </div>

                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    style={{
                                        background: '#850C85',
                                        color: '#ffffff',
                                        border: 'none',
                                        borderRadius: '12px',
                                        padding: '16px 28px',
                                        fontSize: '1rem',
                                        fontWeight: 800,
                                        cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                        boxShadow: '0 6px 20px rgba(133, 12, 133, 0.3)',
                                        transition: 'all 0.2s',
                                        marginTop: '10px'
                                    }}
                                >
                                    {isSubmitting ? 'Submitting Partner Application...' : 'Submit Partner Application →'}
                                </button>
                            </form>
                        )}
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default Becomepartner;
